// Marketplace Loading Component
// Professional loading experience for the Marketplace section
// Features animated spinner, marketplace logo, and contextual messaging

import './MarketplaceLoading.css';

export function MarketplaceLoading({
  title = "Loading Marketplace",
  subtitle = "Discovering amazing products...",
  showLogo = true,
  className = ''
}) {
  return (
    <div className={`loading-container ${className}`}>
      <div className="loading-panel">
        {showLogo && (
          <img
            src="https://bluedrake42.nyc3.cdn.digitaloceanspaces.com/revolt-site/site-assets/logo/revolt-logo-small-transparent.png"
            alt="Revolt Marketplace"
            className="loading-logo"
          />
        )}

        <div className="loading-spinner"></div>

        <div className="loading-content">
          <h3 className="loading-title">{title}</h3>
          <p className="loading-subtitle">{subtitle}</p>
        </div>
      </div>
    </div>
  );
}